var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * 直播延迟控制器模块，具体的延迟计算方式和控制策略由callback处理
 *
 * @export
 * @class LatencyController
 * @typedef {LatencyController}
 */
var LatencyController = /** @class */ (function () {
    function LatencyController(media, config, onLatencyExceeded, onLatencyDropped, latencyCalculationMethod) {
        var _this = this;
        this.onLatencyExceeded = function () { };
        this.onLatencyDropped = function () { };
        this.latencyCalculationMethod = defaultLatencyCalculationMethod;
        this.setupEvents = function () {
            _this.media.addEventListener('timeupdate', _this.onTimeUpdate);
        };
        this.onTimeUpdate = function () {
            var _a = _this.media, buffered = _a.buffered, currentTime = _a.currentTime, paused = _a.paused;
            if (paused)
                return;
            var latency = _this.latencyCalculationMethod(currentTime, buffered);
            if (latency < 0 || isNaN(latency))
                return;
            if (latency > _this.config.expectedLatency && _this.state !== 1 /* Exceeded */) {
                _this.onLatencyExceeded(currentTime, latency, _this.media);
                _this.state = 1 /* Exceeded */;
            }
            else if (latency <= _this.config.minLatency && _this.state !== 0 /* Normal */) {
                _this.onLatencyDropped(currentTime, latency, _this.media);
                _this.state = 0 /* Normal */;
            }
        };
        this.media = media;
        this.config = __assign(__assign({}, defaultConfig), config);
        this.state = 0 /* Normal */;
        if (typeof onLatencyExceeded === 'function')
            this.onLatencyExceeded = onLatencyExceeded;
        if (typeof onLatencyDropped === 'function')
            this.onLatencyDropped = onLatencyDropped;
        if (typeof latencyCalculationMethod === 'function')
            this.latencyCalculationMethod = latencyCalculationMethod;
        this.setupEvents();
    }
    LatencyController.prototype.destroy = function () {
        this.media.removeEventListener('timeupdate', this.onTimeUpdate);
        this.onLatencyExceeded = null;
        this.onLatencyDropped = null;
        this.latencyCalculationMethod = null;
    };
    return LatencyController;
}());
export { LatencyController };
var defaultConfig = {
    expectedLatency: 5,
    minLatency: 2,
    syncSpeed: 1.75,
};
function defaultLatencyCalculationMethod(currentTime, buffered) {
    if (!(buffered.length > 0 && currentTime > 0))
        return -1;
    for (var i = 0; i < buffered.length; i++) {
        var start = buffered.start(i);
        var end = buffered.end(i);
        if (currentTime >= start && currentTime <= end) {
            return end - currentTime;
        }
    }
}
